<template>
    <div class="block">
        <el-pagination
            size="mini"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
/*
 *@description: 分页组件
 *@author: Conan
 *@date: 2021-08-30 20:44:38
 *$emit:
    size-change: pageSize 改变时会触发;
    current-change: currentPage 改变时会触发;
    prev-click: 用户点击上一页按钮改变当前页后触发;
    next-click: 用户点击下一页按钮改变当前页后触发;
*/
// import { isEmpty } from '@/utils/methods';

export default {
    name: 'CAVPaginationV2',
    props: {
        // 数据总条数
        total: {
            type: Number,
            require: true,
        },
        // 每页显示的条数
        pageSize: {
            type: Number,
            default: 10,
        },
        // 每页显示个数选择器
        pageSizes: {
            type: Array,
            default: () => {
                return [10, 20, 30, 40];
            },
        },
        // 页码按钮的数量
        pagerCount: {
            type: Number,
            default: 5,
        },
        // 默认当前页
        currentPage: {
            type: Number,
            default: 1,
        },
        // 布局显示内容
        /**
         * sizes: 条数选择
         * total: 总数显示
         * total-page: 总页数
         * jumper: 跳转输入框
         * group-previous: 组翻页
         * group-next: 组翻页
         *
         * pager-previous: 上一页
         * pager-next: 下一页
         * pager: 页码
         */
        // layout: {
        //     type: Array,
        //     default: () => {
        //         return ['sizes', 'total', 'group-previous', 'pager', 'group-next', 'jumper'];
        //     },
        // },
    },
    components: {},
    data() {
        return {
        };
    },
    computed: {},
    watch: {},
    created() {},

    mounted() {},

    methods: {
        handleSizeChange(val) {
    
        this.$emit('size-change',val)
        },
        handleCurrentChange(val) {
            this.$emit('current-change',val)
        }
    },
};
</script>
<style lang="scss" scoped>
.block{
    ::v-deep .el-pagination{
        font-weight: 400;
        span{
            font-size: 12px;
        }
        .el-pager li {
            font-size: 12px;
            min-width: 30px;
        }
        .el-pagination__jump {
            margin-left: 0; 
            font-weight: 400;
            color: #606266;
        }
        .el-pagination .el-select .el-input {
            width: 100px;
            margin: 0 ; 
        }
        .el-input__inner {
            height: 26px !important;
            line-height: 26px !important;
            font-size: 12px;
        }
        .el-input__icon {
            line-height: 26px !important;
        }
    }
}

</style>
